import { OtherTheme, Theme } from '@api/api/earnings-insights';

export const isTheme = (item: Theme | OtherTheme): item is Theme => {
  return 'theme_id' in item;
};
